import React from 'react'
import type { Icon } from 'shared/utils'

const CheckBold = (props: Icon) => {
    const { color = 'white', size = 24, className = 'check' } = props
    return (
        <svg
            className={className}
            width={size}
            viewBox="0 0 24 24"
            height={size}
            fill={color}
            xmlnsXlink="http://www.w3.org/1999/xlink"
            preserveAspectRatio="none">
            <path
                d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { CheckBold }
